.metaGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-lg);
  margin-top: var(--spacing-xl);
}

@media (max-width: 900px) {
  .metaGrid {
    grid-template-columns: 1fr;
  }
}
